import { Button, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  FormDialog,
  FormLayout,
  FormItem,
  Input,
  NumberPicker,
} from "@formily/antd";
import { createSchemaField } from "@formily/react";
import { setting as settingService } from "@/services";
const schema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "名称",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    value: {
      type: "string",
      title: "分值",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "NumberPicker",
    },
  },
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    NumberPicker,
  },
});

function ReportTypeAddButton({ token, callback }) {
  return (
    <FormDialog.Portal>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => {
          FormDialog({ title: "新增" }, "modal-dialog", () => {
            return (
              <FormLayout labelCol={6} wrapperCol={16}>
                <SchemaField
                  schema={schema}
                  scope={{
                    token,
                  }}
                />
              </FormLayout>
            );
          })
            .forConfirm((payload, next) => {
              settingService
                .addReportType(payload.values, token)
                .then((res) => {
                  message.success("新增成功");
                  callback(Date.now());
                })
                .catch((err) => {
                  message.error(err.message || err);
                })
                .finally(() => {
                  next(payload);
                });
            })
            .open();
        }}
      >
        新 增
      </Button>
    </FormDialog.Portal>
  );
}

export default ReportTypeAddButton;
